import axios from 'axios';
import { IBasePerformanceDetails, IReserveRequest } from '../classes/add-ons';

export default class AddonsApi {

    private static filtersSource = axios.CancelToken.source();

    public static getPerformancePricingApi(performanceId: number, availablePriceTypes: string): Promise<IBasePerformanceDetails> {

        var requestString = `/${process.env.ADDONS_API_ROUTE}/AddOnPerformance?performanceId=${performanceId}&availablePriceTypes=${availablePriceTypes}`;

        return axios.get<IBasePerformanceDetails>(requestString, {
            withCredentials: true,
            cancelToken: this.filtersSource.token
        }).then(response => response.data);
    }

    public static processAddons(request: IReserveRequest[],seated: boolean, configId: number) {
        var requestString = `/${process.env.ADDONS_API_ROUTE}/ProcessAddOnsRequest`;
        const addOnRequests = {
            reserveRequest: request,
            seated: seated,
            configId: configId
        };
        return axios.post(requestString, addOnRequests, { method: "POST" }).then(response => response.data);
    }
}
